import {IUser, ISharedOption, IRole, ResourceSharingSettings} from '../models';

type User = IUser | null | undefined;

/* these roles correspond to the built-in roles on the BE side */
export const ROLE_ADMIN = 'admin';
export const ROLE_GUEST = 'guest';
export const ROLE_USER = 'user';
export const ROLE_LEGACY_PM_USER = 'legacy_pm_user';

export const ROLE_EVERYONE = 'everyone';

/*
 * These roles are defined on the BE
 */
export const MAIN_ROLES = [
  ROLE_ADMIN,
  ROLE_USER,
  ROLE_GUEST,
  ROLE_EVERYONE,
  ROLE_LEGACY_PM_USER,
]

export function isLoggedIn(user?: User) {
  if (user) {
    return user.logged_in || false;
  }
  return false;
  // const accessToken = document.getElementById('access_token') as HTMLInputElement;
  //
  // return accessToken.value !== '';
}

function getRole(roles: any[] | undefined | null, name: string) {
  if (!roles) {
    return null;
  }
  const role = roles.find(role => ((role && role.name) || '').toLowerCase() === name);

  return role ? role : null;
}

export function isAdmin(user?: User) {
  return getRole(user?.roles || [user?.main_role], ROLE_ADMIN) !== null;
}

export function isGuest(user?: User) {
  const userNotAdmin = !isAdmin(user);
  const userIsGuest = getRole(user?.roles || [user?.main_role], ROLE_GUEST) !== null;



  return userNotAdmin && userIsGuest;
}

export function isUser(user?: User) {
  const userNotAdmin = !isAdmin(user);
  const userIsUser = getRole(user?.roles || [user?.main_role], ROLE_USER) !== null;

  return userNotAdmin && userIsUser;
}

export function isLegacyPmUser(user?: User) {
  return getRole(user?.roles || [user?.main_role], ROLE_LEGACY_PM_USER) !== null;
}

export function userIsType(user?: User) {
  if (isAdmin(user)) {
    return ROLE_ADMIN;
  } else if (isGuest(user)) {
    return ROLE_GUEST;
  } else if (isUser(user)) {
    return ROLE_USER;
  }
  return null;
}

export function canViewOnly(currentUserPermissions: ISharedOption | null) {
  return (
    currentUserPermissions &&
    currentUserPermissions.view &&
    !currentUserPermissions.edit
  ) || false;
}

export function isOwner(user?: User, resource?: any) {
  if (!user || !resource) {
    return false;
  }

  return (!!resource.created_by?.uid && resource.created_by?.uid === user.uid) || false;
}

export function isUserDefinedRole(role: IRole): boolean {
  if (!role?.name) {
    return false;
  }
  if (role.name?.startsWith('(user_uid:')) {
    // user's own_role, assigned on user create
    return false;
  }
  return ![ROLE_ADMIN, ROLE_USER, ROLE_GUEST, ROLE_EVERYONE, ROLE_LEGACY_PM_USER].includes(role.name?.toLowerCase());
}

export function isMainRole(role: IRole): boolean {
  return !isUserDefinedRole(role);
}

export function canUserEditResource(user: IUser, sharingSettings: ResourceSharingSettings | null): boolean {
  /*
   * User can be `currentUser`.
   * Resource can be: database, integration, report
   *
   * Similar logic can also be found in `reports/hooks/useReadOnly`
   */
  let canEdit = false;
  if (isAdmin(user)) {
    return true;
  } else if (isUser(user)) {
    if (!sharingSettings) {
      return false;
    }
    if (sharingSettings.shared_with_workspace.edit) {
      return true;
    }
    if (sharingSettings.shared_with_groups?.length) {
      const roleIds = user.roles?.map((r: any) => r.uid) || [];

      sharingSettings.shared_with_groups.forEach((group: any) => {
        if (roleIds.indexOf(group.uid) >= 0 && group.edit) {
          // shared with user's group found
          canEdit = true;
        }
      });
    }
    if (!canEdit && sharingSettings.shared_with_users?.length) {
      sharingSettings.shared_with_users.forEach((user_: any) => {
        if (user.uid === user_.uid && user_.edit) {
          canEdit = true;
        }
      })
    }
  }
  return canEdit;
}
